/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProjectContext } from './ProjectContext';
import {
    ProjectContextFromJSON,
    ProjectContextFromJSONTyped,
    ProjectContextToJSON,
} from './ProjectContext';
import type { WorkItemContext } from './WorkItemContext';
import {
    WorkItemContextFromJSON,
    WorkItemContextFromJSONTyped,
    WorkItemContextToJSON,
} from './WorkItemContext';

/**
 * 
 * @export
 * @interface OggRequestContext
 */
export interface OggRequestContext {
    /**
     * 
     * @type {WorkItemContext}
     * @memberof OggRequestContext
     */
    workItem?: WorkItemContext;
    /**
     * 
     * @type {ProjectContext}
     * @memberof OggRequestContext
     */
    project?: ProjectContext;
}

/**
 * Check if a given object implements the OggRequestContext interface.
 */
export function instanceOfOggRequestContext(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OggRequestContextFromJSON(json: any): OggRequestContext {
    return OggRequestContextFromJSONTyped(json, false);
}

export function OggRequestContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): OggRequestContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workItem': !exists(json, 'workItem') ? undefined : WorkItemContextFromJSON(json['workItem']),
        'project': !exists(json, 'project') ? undefined : ProjectContextFromJSON(json['project']),
    };
}

export function OggRequestContextToJSON(value?: OggRequestContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workItem': WorkItemContextToJSON(value.workItem),
        'project': ProjectContextToJSON(value.project),
    };
}

